// src/pages/merchant/Messages.js
// Messagerie marchand : questions des clients
// Maxula
import React from 'react';
import ChatView from '../../components/chat/ChatView';

const MerchantMessages = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 mb-4">Messages clients</h1>
    <ChatView as="merchant" />
  </div>
);

export default MerchantMessages;
